import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Label,
  Row,
  Col,
} from "reactstrap";
import Select from "react-select";
import { fixedWidthCustomStyle } from "constants/CommonConstants";
import { LEVEL_OPTIONS, TAG_OPTIONS, QUESTION_BANK_OPTIONS} from "components/constant";

const initialFields = {
  level: { value: "", error: "" },
  tag: { value: "", error: "" },
  questionBank: { value: "", error: "" },
};

const ExistingQuestionModal = ({ isOpen, toggleModal, onSave }) => {
  const [fields, setFields] = useState(initialFields);

  useEffect(() => {
    if (!isOpen) setFields(initialFields);
  }, [isOpen]);

  const handleChange = (name, value) => {
    setFields((prev) => ({
      ...prev,
      [name]: {
        value,
        error: "",
      },
    }));
  };

  const isQuestionBankDisabled =
    !fields.level.value || !fields.tag.value;

  const handleSave = () => {
    onSave({
      level: fields.level.value,
      tag: fields.tag.value,
      questionBank: fields.questionBank.value,
    });
  };

  return (
    <>
      {isOpen && <div className="blur-overlay"></div>}

      <Modal
        isOpen={isOpen}
        toggle={toggleModal}
        backdrop={false}
        keyboard={false}
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggleModal}>
          Select Existing Question
        </ModalHeader>

        <ModalBody>
          {/* LEVEL + TAG SAME ROW */}
          <Row className="mb-3">
            <Col md="6">
              <Label>Level <span className="text-danger">*</span></Label>
              <Select
                styles={fixedWidthCustomStyle("100%")}
                options={LEVEL_OPTIONS}
                placeholder="Select Level"
                value={LEVEL_OPTIONS.find(
                  (opt) => opt.value === fields.level.value
                )}
                onChange={(selected) =>
                  handleChange("level", selected.value)
                }
              />
            </Col>

            <Col md="6">
              <Label>Tag <span className="text-danger">*</span></Label>
              <Select
                styles={fixedWidthCustomStyle("100%")}
                options={TAG_OPTIONS}
                placeholder="Select Tag"
                value={TAG_OPTIONS.find(
                  (opt) => opt.value === fields.tag.value
                )}
                onChange={(selected) =>
                  handleChange("tag", selected.value)
                }
              />
            </Col>
          </Row>

          {/* QUESTION BANK */}
          <div className="mb-3">
            <Label>
              Question Bank <span className="text-danger">*</span>
            </Label>
            <Select
              styles={fixedWidthCustomStyle("100%")}
              options={QUESTION_BANK_OPTIONS} 
              placeholder="Select Question Bank"
              value={QUESTION_BANK_OPTIONS.find(
                  (opt) => opt.value === fields.questionBank.value
                )}
              isDisabled={isQuestionBankDisabled}
              onChange={(selected) =>
                handleChange("questionBank", selected.value)
              }
            />
          </div>

          {/* ACTION BUTTONS */}
          <div className="d-flex justify-content-end mt-4">
            <Button
              color="secondary"
              onClick={toggleModal}
              className="mr-2 px-4"
            >
              Cancel
            </Button>

            <Button
              color="deep-blue"
              onClick={handleSave}
              disabled={
                !fields.level.value ||
                !fields.tag.value ||
                !fields.questionBank.value
              }
              className="px-4"
            >
              Save
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ExistingQuestionModal;